// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardHover[data-v-2ef59d8d]:hover {\n  background-color: #ffda69;\n}\n", ""]);
// Exports
module.exports = exports;
